var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_664)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9 1.66666C12.2498 1.66675 12.5907 1.77689 12.8744 1.9815C13.1581 2.1861 13.3703 2.47478 13.4808 2.80666L13.9333 4.16666H16.6667C16.8877 4.16666 17.0996 4.25445 17.2559 4.41073C17.4122 4.56701 17.5 4.77898 17.5 4.99999C17.5 5.221 17.4122 5.43296 17.2559 5.58925C17.0996 5.74553 16.8877 5.83332 16.6667 5.83332H15.8333V15.8333C15.8333 16.4964 15.5699 17.1322 15.1011 17.6011C14.6323 18.0699 13.9964 18.3333 13.3333 18.3333H6.66667C6.00363 18.3333 5.36774 18.0699 4.8989 17.6011C4.43006 17.1322 4.16667 16.4964 4.16667 15.8333V5.83332H3.33333C3.11232 5.83332 2.90036 5.74553 2.74408 5.58925C2.5878 5.43296 2.5 5.221 2.5 4.99999C2.5 4.77898 2.5878 4.56701 2.74408 4.41073C2.90036 4.25445 3.11232 4.16666 3.33333 4.16666H6.06667L6.51917 2.80666C6.62975 2.47465 6.84203 2.18587 7.12592 1.98125C7.4098 1.77664 7.75089 1.66657 8.10083 1.66666H11.9ZM14.1667 5.83332H5.83333V15.8333C5.83333 16.0543 5.92113 16.2663 6.07741 16.4226C6.23369 16.5789 6.44565 16.6667 6.66667 16.6667H13.3333C13.5543 16.6667 13.7663 16.5789 13.9226 16.4226C14.0789 16.2663 14.1667 16.0543 14.1667 15.8333V5.83332ZM11.9 3.33332H8.1L7.8225 4.16666H12.1775L11.9 3.33332Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.768102dc4813a91b1dca4b9ecac1a04e.svg";
export { ForwardRef as ReactComponent };